import { privateAxios } from "@/common/api/axios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { BankInstitutionResponse, BankInstitutionData } from "../types/bankInstitution";

const useBankInstitution: (id: string) => UseQueryResult<BankInstitutionData, unknown> = (id) => {
  return useQuery<BankInstitutionResponse, unknown, BankInstitutionData>({
    queryKey: ['bankInstitution', id],
    queryFn: () => privateAxios.get(`/bank_institutions/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useBankInstitution;
